import store from '../store'
import VueCookie from 'vue-cookie'

export default function (to, from, next) {
  if (VueCookie.get('accessToken') || store.getters.accessToken) {
    next()
  } else {
    next('/login?loginError=true')
  }
}



// WEBPACK FOOTER //
// ./src/router/auth-guard.js